var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ReactTailwindTable from 'react-tailwind-table';
import { getStyles } from './styles';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import { Checkbox, FormInput } from '../form-fields';
import Button from '../button/button';
import { classNames, renderIcon } from '../../utils';
import SearchDropDown from '../dropdown/search-dropdown/search-dropdown';
import { DatePicker } from '../date-picker';
import LoadingSpinner from '../loading-spinner/loading-spinner';
export var Table = forwardRef(function (_a, ref) {
    var _b, _c;
    var initialSelectedRows = _a.selectedRows, multiSelect = _a.multiSelect, rows = _a.rows, columns = _a.columns, _d = _a.rowsPerPage, rowsPerPage = _d === void 0 ? 10 : _d, search = _a.search, actionButton = _a.actionButton, bulkActions = _a.bulkActions, filters = _a.filters, onClearFilters = _a.onClearFilters, onClickRow = _a.onClickRow, onChangePage = _a.onChangePage, loading = _a.loading, _e = _a.noContentText, noContentText = _e === void 0 ? '-' : _e, onChangeSelectedRows = _a.onChangeSelectedRows, watchMode = _a.watchMode, styling = _a.styling;
    var _f = useState(1), currentPage = _f[0], setCurrentPage = _f[1];
    var _g = useState([]), selectedRows = _g[0], setSelectedRows = _g[1];
    var _h = useState(false), openFilters = _h[0], setOpenFilters = _h[1];
    var tableRef = useRef(null);
    useImperativeHandle(ref, function () { return ({
        resetSelectedRows: function () {
            setSelectedRows([]);
            onChangeSelectedRows === null || onChangeSelectedRows === void 0 ? void 0 : onChangeSelectedRows([]);
        },
    }); });
    var totalPages = Math.ceil((rows === null || rows === void 0 ? void 0 : rows.length) / rowsPerPage);
    var selectedFilters = filters === null || filters === void 0 ? void 0 : filters.filter(function (filter) {
        var _a;
        if ((filter === null || filter === void 0 ? void 0 : filter.type) === 'date-picker') {
            return (filter === null || filter === void 0 ? void 0 : filter.value) || (filter === null || filter === void 0 ? void 0 : filter.startDate);
        }
        return (_a = filter === null || filter === void 0 ? void 0 : filter.selectedOptions) === null || _a === void 0 ? void 0 : _a.length;
    });
    var rowsWithKey = rows === null || rows === void 0 ? void 0 : rows.map(function (row, index) {
        var _a;
        return (__assign(__assign({}, row), { key: (_a = row === null || row === void 0 ? void 0 : row.key) !== null && _a !== void 0 ? _a : index, checked: false }));
    });
    var handleRowSelect = function (row) {
        var rowIndex = selectedRows.findIndex(function (selectedRow) { return selectedRow.key === row.key; });
        if (rowIndex > -1) {
            var updatedRows = selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.filter(function (_, index) { return index !== rowIndex; });
            setSelectedRows(updatedRows);
            onChangeSelectedRows === null || onChangeSelectedRows === void 0 ? void 0 : onChangeSelectedRows(updatedRows);
        }
        else {
            var updatedRows = __spreadArray(__spreadArray([], selectedRows, true), [row], false);
            setSelectedRows(updatedRows);
            onChangeSelectedRows === null || onChangeSelectedRows === void 0 ? void 0 : onChangeSelectedRows(updatedRows);
        }
    };
    var handleColumnSelect = function () {
        if (selectedRows.length) {
            onChangeSelectedRows === null || onChangeSelectedRows === void 0 ? void 0 : onChangeSelectedRows([]);
            return setSelectedRows([]);
        }
        onChangeSelectedRows === null || onChangeSelectedRows === void 0 ? void 0 : onChangeSelectedRows(rowsWithKey);
        return setSelectedRows(rowsWithKey);
    };
    var customRowElements = function (row, column, displayValue) {
        if (column.field === 'select') {
            return displayValue;
        }
        if (!!onClickRow) {
            return (_jsx("button", __assign({ className: "w-full truncate text-left", onClick: function () { return onClickRow(row); } }, { children: displayValue })));
        }
        return _jsx("div", { children: displayValue });
    };
    var mergedColumns = (bulkActions === null || bulkActions === void 0 ? void 0 : bulkActions.length) || multiSelect
        ? __spreadArray([
            {
                field: 'select',
                use: (_jsx(Checkbox, { checkboxColor: "textLight", indeterminate: (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length) > 0 &&
                        selectedRows.length < rows.length, checked: (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length) === (rows === null || rows === void 0 ? void 0 : rows.length), onCheckboxChange: handleColumnSelect })),
            }
        ], columns, true)
        : columns;
    var mergedRows = (bulkActions === null || bulkActions === void 0 ? void 0 : bulkActions.length) || multiSelect
        ? rowsWithKey === null || rowsWithKey === void 0 ? void 0 : rowsWithKey.map(function (row) {
            var checked = selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.some(function (selectedRow) { return selectedRow.key === row.key; });
            return __assign(__assign({}, row), { checked: checked, select: (_jsx(Checkbox, { checkboxColor: "textLight", checked: checked, onCheckboxChange: function () { return handleRowSelect(row); } })) });
        })
        : rowsWithKey;
    var tableKey = watchMode
        ? rows === null || rows === void 0 ? void 0 : rows.map(function (row) { return "".concat(row.key, "_").concat(row.checked); }).join('-')
        : undefined;
    useEffect(function () {
        if (initialSelectedRows !== undefined) {
            setSelectedRows(initialSelectedRows);
        }
    }, [initialSelectedRows]);
    useEffect(function () {
        var nextButton = document.querySelector('.next-button');
        var handleNextButtonClick = function () {
            if (currentPage < totalPages) {
                var value = currentPage + 1;
                setCurrentPage(value);
                onChangePage === null || onChangePage === void 0 ? void 0 : onChangePage(value);
            }
        };
        if (nextButton) {
            nextButton.addEventListener('click', handleNextButtonClick);
        }
        return function () {
            if (nextButton) {
                nextButton.removeEventListener('click', handleNextButtonClick);
            }
        };
    }, [currentPage, totalPages, onChangePage]);
    useEffect(function () {
        var backButton = document.querySelector('.back-button');
        var handleNextButtonClick = function () {
            if (currentPage > 1) {
                var value = currentPage - 1;
                setCurrentPage(value);
                onChangePage === null || onChangePage === void 0 ? void 0 : onChangePage(value);
            }
        };
        if (backButton) {
            backButton.addEventListener('click', handleNextButtonClick);
        }
        return function () {
            if (backButton) {
                backButton.removeEventListener('click', handleNextButtonClick);
            }
        };
    }, [currentPage, onChangePage]);
    useEffect(function () {
        var handleDocumentClick = function (event) {
            var target = event.target.closest('.page-numbers');
            if (target) {
                var pElement = target.querySelector('p');
                if (pElement) {
                    var value = parseInt((pElement === null || pElement === void 0 ? void 0 : pElement.textContent) || '');
                    if (!isNaN(value)) {
                        setCurrentPage(value);
                        onChangePage === null || onChangePage === void 0 ? void 0 : onChangePage(value);
                    }
                }
            }
        };
        document.addEventListener('click', handleDocumentClick);
        return function () {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, [onChangePage]);
    useEffect(function () {
        var _a, _b;
        if (!!((_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.active_page_number) &&
            currentPage <= totalPages) {
            tableRef.current.state.active_page_number = currentPage;
        }
    }, [tableKey]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex  flex-col" }, { children: [_jsxs("div", __assign({ className: "flex w-full flex-row items-center justify-between" }, { children: [search && (_jsxs("div", __assign({ className: "flex w-3/5 items-center gap-4" }, { children: [_jsx(FormInput, __assign({}, search, { startIcon: "SearchIcon", color: "adminPortalBg", className: "h-auto ".concat(!!actionButton ? 'w-3/4' : 'w-full'), isAdminPortalField: true })), !!(filters === null || filters === void 0 ? void 0 : filters.length) && (_jsxs(Button, __assign({ type: "filled", color: "quatenary", textColor: "white", className: "mt-1 h-11 min-w-max whitespace-normal break-normal rounded-md px-2 py-0 font-semibold text-white", onClick: function () { return setOpenFilters(!openFilters); } }, { children: [!!(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length)
                                                ? "".concat(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length, " ")
                                                : '', "Filter", renderIcon(openFilters ? 'ChevronUpIcon' : 'ChevronDownIcon', 'text-white h-6 w-6')] })))] }))), _jsxs("div", __assign({ className: "ml-auto flex" }, { children: [!!actionButton && actionButton.actionType !== 'date-picker' && (_jsx(Button, __assign({ type: "filled", color: "quatenary", textColor: "white", className: "mt-1 h-11 w-full rounded-md px-2 py-0 hover:bg-gray-300 lg:w-auto" }, actionButton))), (actionButton === null || actionButton === void 0 ? void 0 : actionButton.actionType) === 'date-picker' && (_jsx(DatePicker, __assign({}, actionButton)))] }))] })), (!!((_b = Object.keys(search !== null && search !== void 0 ? search : {})) === null || _b === void 0 ? void 0 : _b.length) ||
                        !!(filters === null || filters === void 0 ? void 0 : filters.length) ||
                        !!((_c = Object.keys(actionButton !== null && actionButton !== void 0 ? actionButton : {})) === null || _c === void 0 ? void 0 : _c.length)) && (_jsx("div", { className: "mt-8" })), openFilters && (_jsxs("div", __assign({ className: "mb-8 flex items-center justify-between" }, { children: [_jsx("div", __assign({ className: "flex flex-wrap items-center gap-2" }, { children: filters === null || filters === void 0 ? void 0 : filters.map(function (filterProps, index) {
                                    if (filterProps === null || filterProps === void 0 ? void 0 : filterProps.hideFilter) {
                                        return null;
                                    }
                                    if ((filterProps === null || filterProps === void 0 ? void 0 : filterProps.type) === 'date-picker') {
                                        return (_jsx(DatePicker, __assign({ className: "w-56" }, filterProps), "filter-".concat(index)));
                                    }
                                    return (_jsx(SearchDropDown, __assign({ isFullWidth: false, displayMenuOverlay: true }, filterProps), "filter-".concat(index)));
                                }) })), _jsx(Button, __assign({ type: "filled", color: "transparent", className: "text-quatenary mt-1 w-36 rounded-xl p-2 shadow-none hover:bg-gray-300", onClick: onClearFilters }, { children: "Clear all" }))] })))] })), !!(selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length) && (_jsxs("div", __assign({ className: "bg-infoMain flex w-full flex-row items-center justify-between px-4 py-2" }, { children: [_jsxs("p", __assign({ className: "text-md w-4/12 text-white" }, { children: [selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length, " Selected"] })), _jsx("div", __assign({ className: "flex w-6/12 flex-row items-center justify-end gap-2" }, { children: bulkActions === null || bulkActions === void 0 ? void 0 : bulkActions.map(function (buttonProps, index) { return (_createElement(Button, __assign({}, buttonProps, { key: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.text) || '' + index, className: classNames('rounded-xl p-2', buttonProps.className), onClick: function () { var _a; return (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(buttonProps, selectedRows); } }))); }) }))] }))), (loading === null || loading === void 0 ? void 0 : loading.isLoading) ? (_jsx(LoadingSpinner, __assign({}, loading))) : (_jsx(ReactTailwindTable, { ref: tableRef, striped: false, show_search: false, should_export: false, columns: mergedColumns, rows: mergedRows, styling: getStyles({
                    rows: rows,
                    rowsPerPage: rowsPerPage,
                    hasSelectColumn: !!((bulkActions === null || bulkActions === void 0 ? void 0 : bulkActions.length) || multiSelect),
                }), per_page: rowsPerPage, row_render: customRowElements, no_content_text: noContentText }, tableKey))] }));
});
//# sourceMappingURL=index.js.map